import path from 'path';
import fs from 'fs-extra';
import chalk from 'chalk';
import inquirer from 'inquirer';

export async function initConfig() {
  const configPath = path.join(process.cwd(), 'feedinbox.config.json');
  
  if (await fs.pathExists(configPath)) {
    const { overwrite } = await inquirer.prompt([
      {
        type: 'confirm',
        name: 'overwrite',
        message: 'FeedInbox config already exists. Overwrite?',
        default: false
      }
    ]);
    
    if (!overwrite) {
      console.log(chalk.yellow('Configuration unchanged.'));
      return;
    }
  }
  
  const answers = await inquirer.prompt([
    {
      type: 'input',
      name: 'apiKey',
      message: 'Enter your FeedInbox API key:',
      validate: (input) => {
        if (!input) return 'API key is required';
        if (!input.startsWith('fb_')) return 'API key must start with "fb_"';
        return true;
      }
    },
    {
      type: 'input',
      name: 'apiUrl',
      message: 'Enter your API URL (optional):',
      default: 'https://api.feedinbox.com'
    },
    {
      type: 'input',
      name: 'workspaceId',
      message: 'Enter your workspace ID (optional):'
    }
  ]);
  
  const config = {
    apiKey: answers.apiKey,
    apiUrl: answers.apiUrl,
    workspaceId: answers.workspaceId || undefined,
    version: '1.0.0',
    createdAt: new Date().toISOString()
  };
  
  await fs.writeJson(configPath, config, { spaces: 2 });
  
  console.log(chalk.green('✅ Configuration saved to feedinbox.config.json'));
  console.log(chalk.yellow('⚠️  Make sure to add feedinbox.config.json to your .gitignore'));
}